// Generated by CoffeeScript 2.7.0
var Admin__Settings__OthersController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsOthers from 'trunks/vue/admin/components/settings/settings_container/settings_others.js';

export default Admin__Settings__OthersController = (function() {
  class Admin__Settings__OthersController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get("/admin/settings/others", {
        responseType: 'json',
        success: function(data) {
          return new SettingsOthers({
            el: DomMaster.find("#js-settings-others").node,
            propsData: {
              activeTab: 'others',
              othersOptions: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__OthersController.include(GenerateMorePopover);

  Admin__Settings__OthersController.include(SettingsNavigator);

  return Admin__Settings__OthersController;

}).call(this);
